import { Controller, useFormContext } from "react-hook-form";
import type { MediaFilterData, MediaFormFields } from "~/features/mediaLibrary/types/mediaLibraryFormTypes";
import classes from "./MediaLibrarySearchBox.module.less";
import MediaFilter from "../MediaFilter/MediaFilter";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/mui";
import { Chip } from "~/common/mui/Chip/Chip";
import CheckIcon from "@mui/icons-material/Check";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { userIsLoggedIn } from "~/domains/user/utils/roles";

export default function MediaLibraryFilters(props: { filterOptions: MediaFilterData }) {
  const { control, reset } = useFormContext<MediaFormFields>();
  const { filterOptions } = props;
  const { mediaTypes, productPortfolios, languages, segments } = filterOptions;

  const { t } = useTranslation();

  const handleReset = () => {
    reset({
      q: "",
      mediaTypes: [],
      productPortfolios: [],
      languages: [],
      segments: [],
      fetchFavourite: false,
      sortOrder: "asc",
    });
  };

  return (
    <div className={classes.filtersContainer}>
      <div className={classes.filters}>
        <Controller
          name="mediaTypes"
          control={control}
          render={({ field: { value, onChange } }) => (
            <MediaFilter
              label={t("media.library.filterLabel.mediaType")}
              options={mediaTypes}
              selectedValues={value}
              onChange={onChange}
            />
          )}
        />

        <Controller
          name="productPortfolios"
          control={control}
          render={({ field: { value, onChange } }) => (
            <MediaFilter
              label={t("media.library.filterLabel.productCategory")}
              options={productPortfolios}
              selectedValues={value}
              onChange={onChange}
            />
          )}
        />

        <Controller
          name="languages"
          control={control}
          render={({ field: { value, onChange } }) => (
            <MediaFilter
              label={t("media.library.filterLabel.language")}
              options={languages}
              selectedValues={value}
              onChange={onChange}
            />
          )}
        />

        <Controller
          name="segments"
          control={control}
          render={({ field: { value, onChange } }) => (
            <MediaFilter
              label={t("media.library.filterLabel.sector")}
              options={segments}
              selectedValues={value}
              onChange={onChange}
            />
          )}
        />
        {userIsLoggedIn() && (
          <Controller
            name="fetchFavourite"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Chip
                variant={"filter"}
                onClick={() => onChange(!value)}
                icon={value ? <CheckIcon /> : undefined}
                label={t("media.library.showOnlyFavourite")}
                selected={value}
              />
            )}
          />
        )}
      </div>

      <Button
        data-test-id={"find-partner"}
        variant="text"
        onClick={handleReset}
        className={classes.clearBtn}
        startIcon={<Icon type={IconType.Reload} />}
      >
        {t("searchPage.refinement.button.clearAll")}
      </Button>
    </div>
  );
}
